import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/mergeMap'

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable, Injector } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { UserAuthProvider } from './user-auth'
import { AuthToken } from './user-auth-models'

@Injectable()
export class UserAuthInterceptor implements HttpInterceptor {

    private userAuthProvider: UserAuthProvider<any>

    constructor(private inj: Injector) {
        console.log('UserAuth-Interceptor init');
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const started = Date.now();
        if (this.userAuthProvider == null) {
            this.userAuthProvider = this.inj.get(UserAuthProvider)
        }

        if (this.userAuthProvider != null) {
            if (req.url.indexOf(this.userAuthProvider.config.authPath) > -1) {
                console.log(`${req.method} - ${req.urlWithParams} - no Token`)
                return next.handle(req)
            }

            return this.userAuthProvider.getAuthToken().flatMap((token: AuthToken) => {
                const authToken = token

                return token && token.access_token ?
                    this.handleCall(next, req, started, token)
                        .catch((res: HttpErrorResponse) => {
                            const elapsed = Date.now() - started;
                            console.log(`${req.urlWithParams} -> ${res.status} ${res.statusText} in ${elapsed}ms`)
                            if (res.status === 401) {
                                console.warn(`### DETECT UNAUTHORIZED REQUEST --- 401 --- `)
                                console.warn(`CALL: ${req.url} IN QUEUE`)
                                if (authToken) {
                                    return this.userAuthProvider.syncronizeRefreshToken(authToken).flatMap(newAuthToken => {
                                        console.warn(` |||||||| Retry with after refresh token -- for: ${req.url}`)
                                        return this.handleCall(next, req, Date.now(), newAuthToken)
                                    })
                                } else {
                                    return this.handleCall(next, req, Date.now())
                                }
                            } else {
                                return Observable.throw(res);
                            }
                        })
                    :
                    this.handleCall(next, req, started)
            })
        } else {
            console.error(`CAN'T INJECT LOGINSERVICE IN TOKEN INTERCEPTOR`)
            return next.handle(req)
        }
    }

    private handleCall(next, req, started, authToken: AuthToken = null) {
        let newRequest
        if (authToken && authToken.access_token) {
            newRequest = req.clone({
                headers: req.headers.append(
                    'Authorization',
                    `${authToken.token_type} ${authToken.access_token}`
                )
            });
            console.log(`${req.method} - ${req.urlWithParams} - ${authToken.access_token}`)
        } else {
            newRequest = req
            console.log(`${req.method} - ${req.urlWithParams} - no Token`)
        }
        return next.handle(newRequest)
            .do((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const elapsed = Date.now() - started;
                    console.log(`${req.urlWithParams} -> ${event.status} ${event.statusText} in ${elapsed}ms`)
                }
            })
    }

}



// WEBPACK FOOTER //
// ./src/modules/mrk-user-auth/user-auth-interceptor.ts